import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { setLoading, saveData, setActivePage } from './actions.js';
import UsersList from './component';

class UsersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 50,
      offset: 0,
      status: ''
    };
  }

  componentDidMount() {
    this.props.setLoading(true);
    this.props.setActivePage(1);
    this.loadUserData();
  }

  loadUserData = () => {
    this.props.getDataFromAPI(
      `/users/list?limit=${this.state.limit}&offset=${this.state.offset}`,
      'GET',
      undefined,
      response => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  };

  onClickOfDelete = (name, userId) => {
    if (!confirm(`Are you sure you want to delete "${name}"`)) {
      return;
    }
    // this.props.setLoading(true);

    if (!userId) {
      this.props.setLoading(false);
      return toastr.warning('Invalid', 'Invalid User Id');
    }

    this.props.getDataFromAPI(
      '/users',
      'DELETE',
      { userIdColl: [userId] },
      response => {
        toastr.success('Successful', 'Deleted the user');
        this.props.setLoading(false);
        // return this.props.history.push('/users/list');
        // return window.location.reload();
        this.loadUserData();
      },
      err => {
        this.props.setLoading(false);
       /*  toastr.error('Failed', 'Delete user operation failed'); */
      }
    );
  };

  onPageChange = (e, { activePage }) => {
    this.props.setActivePage(activePage);
    this.props.setLoading(true);

    const URL = `/users/list?limit=${this.state.limit}&offset=${this.state.limit *
      (activePage - 1)}`;

    this.props.getDataFromAPI(
      URL,
      'GET',
      undefined,
      response => {
        console.log("USER-LIST Response-----",response)
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
    this.setState((prevState, props) => {
      return {
        offset: prevState.limit * activePage
      };
    });
  };

  render() {
    const userData =
      this.props.userList && this.props.userList.userList && this.props.userList.userList.list;
    const loading = this.props.userList && this.props.userList.loading;
    const activePage = this.props.userList && this.props.userList.activePage;
    const totalCount =
      this.props.userList && this.props.userList.userList && this.props.userList.userList.total;
    const limit = this.state.limit;

    return (
      <UsersList
        loading={loading}
        usersList={userData}
        activePage={activePage}
        totalPages={totalCount / this.state.limit}
        onPageChange={this.onPageChange}
        onClickOfDelete={this.onClickOfDelete}
        limit={limit}
        totalCount={totalCount}
      />
    );
  }
}

function mapStateToProps({ userList }) {
  return {
    userList
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    setLoading,
    saveData,
    setActivePage
  })(UsersContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UsersList/container.jsx